import { render, staticRenderFns } from "./PageTakeOverSetting.vue?vue&type=template&id=6d6fb0f4"
import script from "./PageTakeOverSetting.vue?vue&type=script&lang=js"
export * from "./PageTakeOverSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports